export default "__VITE_ASSET__Db5m8tJN__"